import Loadable from 'components/Loadable';
import { lazy } from 'react';
import { RouteObject } from 'react-router';

const Inquiry = Loadable(lazy(() => import('./index')));
const List = Loadable(lazy(() => import('./list/index')));
const Form = Loadable(lazy(() => import('./form/index')));

const Approval = Loadable(lazy(() => import('./approval/index')));
const ApprovalForm = Loadable(lazy(() => import('./approval/form/index')));

export const routes: RouteObject[] = [
    {
        path: '/list/kelola-nasabah/kelola-kartu-debit-visa',
        children: [
            {
                index: true,
                element: <Inquiry />,
            },

            {
                path: ':cif',
                element: <List />,
            },
        ],
    },

    {
        path: '/form/kelola-nasabah/kelola-kartu-debit-visa/:id',
        element: <Form />,
    },

    {
        path: '/list/persetujuan/kelola-kartu-debit-visa',
        element: <Approval />,
    },

    {
        path: '/form/persetujuan/kelola-kartu-debit-visa/:id',
        element: <ApprovalForm />,
    },
];
